export default [
    {
        "status": {
            "shortName": "MarriedFilingJointly",
            "enumerationID": 30,
            "enumerationName": "Married Filing Jointly"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.1,
            "minimum": 0.1
        },
        "incomeAmount": 0.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingJointly",
            "enumerationID": 30,
            "enumerationName": "Married Filing Jointly"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.1,
            "minimum": 0.1
        },
        "incomeAmount": 18650.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingSeparately",
            "enumerationID": 20,
            "enumerationName": "Married Filing Separately"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.1,
            "minimum": 0.1
        },
        "incomeAmount": 0.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingSeparately",
            "enumerationID": 20,
            "enumerationName": "Married Filing Separately"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.1,
            "minimum": 0.1
        },
        "incomeAmount": 9325.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "HeadOfHousehold",
            "enumerationID": 40,
            "enumerationName": "Head of Household"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.1,
            "minimum": 0.1
        },
        "incomeAmount": 0.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "HeadOfHousehold",
            "enumerationID": 40,
            "enumerationName": "Head of Household"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.1,
            "minimum": 0.1
        },
        "incomeAmount": 13350.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "Single",
            "enumerationID": 10,
            "enumerationName": "Single"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.15,
            "minimum": 0.15
        },
        "incomeAmount": 9326.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "Single",
            "enumerationID": 10,
            "enumerationName": "Single"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.15,
            "minimum": 0.15
        },
        "incomeAmount": 37950.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingJointly",
            "enumerationID": 30,
            "enumerationName": "Married Filing Jointly"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.15,
            "minimum": 0.15
        },
        "incomeAmount": 18651.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingJointly",
            "enumerationID": 30,
            "enumerationName": "Married Filing Jointly"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.15,
            "minimum": 0.15
        },
        "incomeAmount": 75900.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingSeparately",
            "enumerationID": 20,
            "enumerationName": "Married Filing Separately"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.15,
            "minimum": 0.15
        },
        "incomeAmount": 9326.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingSeparately",
            "enumerationID": 20,
            "enumerationName": "Married Filing Separately"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.15,
            "minimum": 0.15
        },
        "incomeAmount": 37950.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "HeadOfHousehold",
            "enumerationID": 40,
            "enumerationName": "Head of Household"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.15,
            "minimum": 0.15
        },
        "incomeAmount": 13351.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "HeadOfHousehold",
            "enumerationID": 40,
            "enumerationName": "Head of Household"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.15,
            "minimum": 0.15
        },
        "incomeAmount": 50800.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "Single",
            "enumerationID": 10,
            "enumerationName": "Single"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.25,
            "minimum": 0.25
        },
        "incomeAmount": 37951.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "Single",
            "enumerationID": 10,
            "enumerationName": "Single"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.25,
            "minimum": 0.25
        },
        "incomeAmount": 91900.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingJointly",
            "enumerationID": 30,
            "enumerationName": "Married Filing Jointly"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.25,
            "minimum": 0.25
        },
        "incomeAmount": 75901.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingJointly",
            "enumerationID": 30,
            "enumerationName": "Married Filing Jointly"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.25,
            "minimum": 0.25
        },
        "incomeAmount": 153100.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingSeparately",
            "enumerationID": 20,
            "enumerationName": "Married Filing Separately"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.25,
            "minimum": 0.25
        },
        "incomeAmount": 37951.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingSeparately",
            "enumerationID": 20,
            "enumerationName": "Married Filing Separately"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.25,
            "minimum": 0.25
        },
        "incomeAmount": 76550.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "HeadOfHousehold",
            "enumerationID": 40,
            "enumerationName": "Head of Household"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.25,
            "minimum": 0.25
        },
        "incomeAmount": 50801.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "HeadOfHousehold",
            "enumerationID": 40,
            "enumerationName": "Head of Household"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.25,
            "minimum": 0.25
        },
        "incomeAmount": 131200.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "Single",
            "enumerationID": 10,
            "enumerationName": "Single"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.28,
            "minimum": 0.28
        },
        "incomeAmount": 91901.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "Single",
            "enumerationID": 10,
            "enumerationName": "Single"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.28,
            "minimum": 0.28
        },
        "incomeAmount": 191650.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingJointly",
            "enumerationID": 30,
            "enumerationName": "Married Filing Jointly"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.28,
            "minimum": 0.28
        },
        "incomeAmount": 153101.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingJointly",
            "enumerationID": 30,
            "enumerationName": "Married Filing Jointly"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.28,
            "minimum": 0.28
        },
        "incomeAmount": 233350.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingSeparately",
            "enumerationID": 20,
            "enumerationName": "Married Filing Separately"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.28,
            "minimum": 0.28
        },
        "incomeAmount": 76551.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingSeparately",
            "enumerationID": 20,
            "enumerationName": "Married Filing Separately"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.28,
            "minimum": 0.28
        },
        "incomeAmount": 116675.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "HeadOfHousehold",
            "enumerationID": 40,
            "enumerationName": "Head of Household"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.28,
            "minimum": 0.28
        },
        "incomeAmount": 131201.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "HeadOfHousehold",
            "enumerationID": 40,
            "enumerationName": "Head of Household"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.28,
            "minimum": 0.28
        },
        "incomeAmount": 212500.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "Single",
            "enumerationID": 10,
            "enumerationName": "Single"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.33,
            "minimum": 0.33
        },
        "incomeAmount": 191651.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "Single",
            "enumerationID": 10,
            "enumerationName": "Single"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.33,
            "minimum": 0.33
        },
        "incomeAmount": 416700.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingJointly",
            "enumerationID": 30,
            "enumerationName": "Married Filing Jointly"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.33,
            "minimum": 0.33
        },
        "incomeAmount": 233351.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingJointly",
            "enumerationID": 30,
            "enumerationName": "Married Filing Jointly"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.33,
            "minimum": 0.33
        },
        "incomeAmount": 416700.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingSeparately",
            "enumerationID": 20,
            "enumerationName": "Married Filing Separately"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.33,
            "minimum": 0.33
        },
        "incomeAmount": 116676.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingSeparately",
            "enumerationID": 20,
            "enumerationName": "Married Filing Separately"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.33,
            "minimum": 0.33
        },
        "incomeAmount": 208350.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "HeadOfHousehold",
            "enumerationID": 40,
            "enumerationName": "Head of Household"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.33,
            "minimum": 0.33
        },
        "incomeAmount": 212501.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "HeadOfHousehold",
            "enumerationID": 40,
            "enumerationName": "Head of Household"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.33,
            "minimum": 0.33
        },
        "incomeAmount": 416700.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "Single",
            "enumerationID": 10,
            "enumerationName": "Single"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.35,
            "minimum": 0.35
        },
        "incomeAmount": 416701.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "Single",
            "enumerationID": 10,
            "enumerationName": "Single"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.35,
            "minimum": 0.35
        },
        "incomeAmount": 418400.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingJointly",
            "enumerationID": 30,
            "enumerationName": "Married Filing Jointly"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.35,
            "minimum": 0.35
        },
        "incomeAmount": 416701.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingJointly",
            "enumerationID": 30,
            "enumerationName": "Married Filing Jointly"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.35,
            "minimum": 0.35
        },
        "incomeAmount": 470000.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingSeparately",
            "enumerationID": 20,
            "enumerationName": "Married Filing Separately"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.35,
            "minimum": 0.35
        },
        "incomeAmount": 208351.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingSeparately",
            "enumerationID": 20,
            "enumerationName": "Married Filing Separately"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.35,
            "minimum": 0.35
        },
        "incomeAmount": 235350.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "HeadOfHousehold",
            "enumerationID": 40,
            "enumerationName": "Head of Household"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.35,
            "minimum": 0.35
        },
        "incomeAmount": 416701.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "HeadOfHousehold",
            "enumerationID": 40,
            "enumerationName": "Head of Household"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.35,
            "minimum": 0.35
        },
        "incomeAmount": 444550.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "Single",
            "enumerationID": 10,
            "enumerationName": "Single"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.396,
            "minimum": 0.396
        },
        "incomeAmount": 418401.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "Single",
            "enumerationID": 10,
            "enumerationName": "Single"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.396,
            "minimum": 0.396
        },
        "incomeAmount": 0.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingJointly",
            "enumerationID": 30,
            "enumerationName": "Married Filing Jointly"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.396,
            "minimum": 0.396
        },
        "incomeAmount": 470001.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingJointly",
            "enumerationID": 30,
            "enumerationName": "Married Filing Jointly"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.396,
            "minimum": 0.396
        },
        "incomeAmount": 0.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingSeparately",
            "enumerationID": 20,
            "enumerationName": "Married Filing Separately"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.396,
            "minimum": 0.396
        },
        "incomeAmount": 235351.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "MarriedFilingSeparately",
            "enumerationID": 20,
            "enumerationName": "Married Filing Separately"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.396,
            "minimum": 0.396
        },
        "incomeAmount": 0.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "HeadOfHousehold",
            "enumerationID": 40,
            "enumerationName": "Head of Household"
        },
        "valueStatus": {
            "enumerationID": 555,
            "enumerationName": "Minimum"
        },
        "taxRate": {
            "maximum": 0.396,
            "minimum": 0.396
        },
        "incomeAmount": 444551.0,
        "longTermCapitalGain": 0.0
    },
    {
        "status": {
            "shortName": "HeadOfHousehold",
            "enumerationID": 40,
            "enumerationName": "Head of Household"
        },
        "valueStatus": {
            "enumerationID": 556,
            "enumerationName": "Maximum"
        },
        "taxRate": {
            "maximum": 0.396,
            "minimum": 0.396
        },
        "incomeAmount": 0.0,
        "longTermCapitalGain": 0.0
    }
]